// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3RUlD","modalForm":"UpgradeEpcsModal_modalForm__3n_5i","modalFooter":"UpgradeEpcsModal_modalFooter__2wBuD"};